module.exports = __webpack_public_path__ + "img/cangku.79566b85.png";